import { ActivatedRoute } from "@angular/router";
import { TowerService } from "../../api/service/tower.service";
var LogitemComponent = /** @class */ (function () {
    function LogitemComponent(route, towerService) {
        this.route = route;
        this.towerService = towerService;
    }
    LogitemComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.paramMap.subscribe(function (params) {
            var itemId = params.get('id');
            _this.towerService.recupererLogitem(itemId).subscribe(function (item) {
                _this.item = item;
                _this.keys = Object.keys(item);
            }, function (error) { return alert('Erreur durant le chargement des données'); });
        });
    };
    return LogitemComponent;
}());
export { LogitemComponent };



// WEBPACK FOOTER //
// ./src/app/page/logitem/logitem.component.ts.pre-build-optimizer.js